import { Component, computed, input } from '@angular/core';

import { richTextResolver, StoryblokRichTextNode } from '@storyblok/richtext';
import { DynamicModule } from 'ng-dynamic-component';
import { SwiperOptions } from 'swiper/types';

import { SlideComponent } from '@valk-nx/components/ui-slider/src/lib/slide/slide';
import { SliderComponent } from '@valk-nx/components/ui-slider/src/lib/slider';
import { ItemSlide } from '@valk-nx/components/ui-slider/src/lib/slider.interface';
import { HeadingGroupSectionComponent } from '@valk-nx/storyblok/components/heading-group-section/src/lib/heading-group-section';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import {
	HeadingGroupSection,
	ItemSliderItem,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-items-slider-section',
	templateUrl: './items-slider-section.html',
	imports: [
		DynamicModule,
		HeadingGroupSectionComponent,
		SlideComponent,
		SliderComponent,
		StoryblokDirective,
	],
})
export class StoryblokItemsSliderComponent extends StoryblokRootDirective {
	title = input.required<HeadingGroupSection[]>();
	items = input<ItemSliderItem[]>([]);
	config = input<Partial<SwiperOptions>>({});

	renderedRichTextTitle = computed<string | StoryblokRichTextNode<string>>(
		() => {
			const titleArray = this.title();
			const heading = titleArray?.[0];
			if (!heading?.title) {
				return '';
			}

			const title = heading.title;
			if (typeof title === 'string') {
				return title;
			}

			const content = title.content?.[0]?.content?.[0];
			if (content) {
				return richTextResolver<string>({}).render(
					content as StoryblokRichTextNode<string>,
				);
			}
			return '';
		},
	);

	trackByUrl = (item: ItemSlide) => item.link.url;

	itemSliderItems = computed<ItemSlide[]>(() =>
		this.items().map((item) => {
			return {
				overline: item.overline,
				title: item.title,
				image: {
					src: item.bynder[0].files.transformBaseUrl.url,
					alt: item.imageAlt,
				},
				link: {
					url: item.link.cached_url,
					title: item.title,
					target: item.link.target ?? '_self',
					fragment: item.fragment,
				},
			};
		}),
	);
}
